<template>
  <section>
    <!--工具条-->
    <Toolbar :buttonList="buttonList" @callFunction="callFunction"></Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
    >
      <el-table-column prop="NickName" :label="$t('AdminUser.NickName')" width sortable></el-table-column>
      <el-table-column prop="LoginName" :label="$t('AdminUser.LoginName')" width sortable></el-table-column>
      <el-table-column prop="Role.Name" :label="$t('AdminUser.RoleName')" width sortable></el-table-column>
      <el-table-column prop="Enabled" :label="$t('Enabled')" width="200" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled  ? 'success' : 'danger'"
            disable-transitions
          >{{scope.row.Enabled ? $t('enabled'):$t('disable')}}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="130px" ref="editForm">
        <el-form-item
          :label="$t('AdminUser.NickName')"
          prop="NickName"
          :rules="{required: true, message: $t('pleaseEnter')+$t('AdminUser.NickName')}"
        >
          <el-input v-model="editForm.NickName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('AdminUser.LoginName')" prop="LoginName">
          <span>{{editForm.LoginName}}</span>
        </el-form-item>
        <el-form-item :label="$t('AdminUser.RoleName')" prop="RoleId">
          <el-select v-model="editForm.RoleId" placeholder="Select role">
            <el-option v-for="item in roles" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Enabled')">
          <el-switch v-model="editForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">{{$t('submit')}}</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="130px" ref="addForm">
        <el-form-item
          :label="$t('AdminUser.NickName')"
          prop="NickName"
          :rules="{required: true, message: $t('pleaseEnter')+$t('AdminUser.NickName')}"
        >
          <el-input v-model="addForm.NickName"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('AdminUser.LoginName')"
          prop="LoginName"
          :rules="{required: true, message: $t('pleaseEnter')+$t('AdminUser.LoginName')}"
        >
          <el-input v-model="addForm.LoginName"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('AdminUser.Password')"
          prop="LoginPWD"
          :rules="{required: true, message: $t('pleaseEnter')+$t('AdminUser.Password')}"
        >
          <el-input v-model="addForm.LoginPWD" show-password></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('AdminUser.RoleName')"
          prop="RoleId"
          :rules="{required: true, message: $t('pleaseEnter')+$t('AdminUser.RoleName')}"
        >
          <el-select v-model.number="addForm.RoleId" placeholder="Select role">
            <el-option v-for="item in roles" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Enabled')">
          <el-switch v-model="addForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">{{$t('submit')}}</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import {
  getUserListPage,
  getRoleListPage,
  removeUser,
  editUser,
  addUser,
  loadPass
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";

export default {
  data() {
    return {
      filters: {
        name: ""
      },
      buttonList: [],
      list: [],
      roles: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {},
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {}
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //获取用户列表
    getList() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getUserListPage(para).then(res => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error"
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeUser(para).then(res => {
            this.listLoading = false;
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit: function() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.clone(row));
      getRoleListPage().then(res => {
        this.roles = res.data.response.data;
      });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        LoginName: "",
        NickName: "",
        LoginPWD: "",
        Enabled: true
      };
      getRoleListPage().then(res => {
        this.roles = res.data.response.data;
      });
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {}).then(
            () => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);
              editUser(para).then(res => {
                this.editLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success"
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
              });
            }
          );
        }
      });
    },
    //新增
    addSubmit: function() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              addUser(para).then(res => {
                this.addLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }

                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success"
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    loadPass() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error"
        });

        return;
      }
      this.$confirm(this.$t("AdminUser.ResetPass"), this.$t("prompt"), {}).then(
        () => {
          let para = {
            id: row.Id
          };
          loadPass(para)
            .then(res => {
              if (res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            })
            .catch(() => {});
        }
      );
    }
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

